
export class BusinessException extends Error {
  constructor(
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    public readonly mensagens: string[]
  ) {
    super();
  }
}
